var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0053 27.334L16 15.334M27.012 22.878C28.0796 22.1273 28.8803 21.0558 29.2977 19.8191C29.7151 18.5824 29.7276 17.2449 29.3333 16.0007C28.5246 13.4474 26.0466 12.048 23.3686 12.0507H21.8213C21.4522 10.611 20.7612 9.27383 19.8005 8.13985C18.8398 7.00587 17.6343 6.10463 16.2748 5.50401C14.9153 4.90338 13.4373 4.61902 11.952 4.67234C10.4667 4.72566 9.01285 5.11526 7.69994 5.81182C6.38702 6.50837 5.24925 7.49372 4.3723 8.69368C3.49534 9.89363 2.90206 11.2769 2.63712 12.7394C2.37219 14.2018 2.4425 15.7053 2.84277 17.1366C3.24304 18.568 3.96284 19.8898 4.94796 21.0027",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2426 18.4253L15.9999 14.1826L11.7573 18.4253",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomUploadIcon);
export default __webpack_public_path__ + "static/media/custom_upload_icon.68e16c990196e94702b92ad875893d21.svg";
export { ForwardRef as ReactComponent };